

<script>
    import WaitIndicator from "../Common/WaitIndicator.vue";
    import OrderActionMenu from './OrderActionMenu.vue'
    import Component from 'vue-class-component'
    import {Prop, Watch, Vue, Emit} from 'vue-property-decorator'    
    import {Order} from "../../domain/Order";
    import PriceCell from './PriceCell.vue'
    import {OrderClassMap, OrderDurationMap, OrderStatusMap, OrderTypeMap, OrderSideMap, PositionEffectMap} from "../../domain/TbMaps";
    import {EventBus, Messages, OrderMessages} from "../../services/EventBus";


    import OrderDetails from './OrderDetails.vue'
    import TableScroller from '../Common/TableScrollable'    

    Vue.component('OrderDetails', OrderDetails);

    export default Vue.extend({
        name:'OrderTable',
        components: {WaitIndicator, OrderActionMenu, PriceCell,TableScroller},
        props:{
            hideColumns:{type:Array, required:false,default:()=>[]},
            loading:{type:Boolean},
            loaded:{type:Boolean},
            data: {required:true},
            ErrorMessage:{default:""},
            editable: {type:Boolean,required:false,default:true}
        },
        data(){
            var cols = ['Date','Description','UnderlyingSymbol',"ActionDesc",'OrderType','OrderStatus',"Quantity", 'FillQuantity',

                'AverageFillPrice','BidPrice','AskPrice'
            ];

            var dat =  {

                msg_closed: false,
                columns: cols.filter(s=>this.hideColumns.indexOf(s)<0),
                options:{
                    uniqueKey:"OrderId",
                    sortable: ['Date', 'Description'],
//                    dateColumns:['Date'],
//                    dateFormat: 'YYYY-MM-DD',
                    filterable:false,
                    headings
                    : {
                        Date: 'Date',
                        OrderType: 'Order Type',
                        OrderStatus: 'Order Status',
                        ActionDesc: 'Action',
                        OrderClass: 'Order Class',
                        Qty0: 'First Leg Qty',
                        UnderlyingSymbol:'Underlying Symbol',
                        FillQuantity:'Fill Quantity',
                        AverageFillPrice:'AVG Fill Price',
                        BidPrice:'Bid',
                        AskPrice:'Ask',

                    },
                    perPageValues: [],
                    childRow: 'OrderDetails'
                },
                scrollWidth: 0, /* width of inner content depend and sync on number of table columns*/
                scrollContWidth: 0, /* width of scroll container and table viewport */
                scrollOffset:  0 // position of inner content to conainer
            }
            this.editable && dat.columns.push('Actions');
            return dat;
        },
        computed: {
            scrollLeft: {
                get() {
                    return this.scrollOffset;
                },
                set(v) {
                    this.scrollOffset = v;
                    $("#TbOrderTable .table-responsive").scrollLeft(v);
                }
            }
        },

        mounted(){

            // sync of scroller wrapper size to size of table container
            this.onResize();
            var self = this;
            window.$(window).resize(this.onResize.bind(self));
        },
        beforeDestroy(){
            window.$(window).removeEventListener('resize');
        },

        // .table-responsive is container
        // .VueTables__table is wide table
        watch: {
            loaded: function(v){
                if (!v) return;
                Vue.nextTick(()=> {
                    // this.data.map(o=>{
                    //   this.$refs.TbOrderTable.toggleChildRow(o.OrderId);
                    // });

                    Vue.nextTick(()=> {


                      this.onResize();
                    });
                });
            },
            advanced: function(v){
                this.options.filterable = v;
                if (v) {
                    this.options.perPageValues = [10,20,50]
                } else
                    this.options.perPageValues = [];
            }
        },
        updated: function Updated() {
            if (this.loaded)
                Vue.nextTick(()=>{
                        this.onResize();
                        $("#TbOrderTable .table-responsive").scroll(()=>
                            this.scrollLeft = $("#TbOrderTable .table-responsive").scrollLeft())
                    }

                );

        },

        methods:{
            onResize (){
                if (this.scrollContWidth != $('#TbOrderTable .table-responsive').outerWidth()) {
                    this.scrollContWidth = $("#TbOrderTable .table-responsive").parent().width();
                    this.scrollWidth = $("#TbOrderTable .VueTables__table").width();
                }
                return false;
            },
           getClassVal(v){
                return OrderClassMap[v];
           },
            getStatusVal(v){
                return OrderStatusMap[v];
            },
            getTypeVal(v){
                return OrderTypeMap[v];
            },
            getDurationVal(v){
                return OrderDurationMap[v];
            },
            Leg0Description(v){
                    if (!v.Legs || !v.Legs[0]) return "";
                    return "Leg 0: "+v.Legs[0].Symbol + " " + OrderSideMap[v.Legs[0].Action] + " to " + PositionEffectMap[v.Legs[0].PositionEffect];
            },
            Leg1Description(v){
                    if (!v.Legs || !v.Legs[1]) return "";
                    return "Leg 1: "+v.Legs[1].Symbol + " " + OrderSideMap[v.Legs[1].Action] + " to " + PositionEffectMap[v.Legs[1].PositionEffect];
            },
            getAction(v){
                var res="";
                if (this.editable){
                    if (v.Legs && v.Legs[0] && !v.Legs[1]) res= OrderSideMap[v.Legs[0].Action];
                    if (v.Legs && v.Legs[0] && v.Legs[1]) res = OrderSideMap[v.Legs[0].Action] + ", " + OrderSideMap[v.Legs[1].Action];
                } else{
                    if (v.Legs && v.Legs[0]) res= OrderSideMap[v.Legs[0].Action] + ' to ' + PositionEffectMap[v.Legs[0].PositionEffect];
                    if (v.Legs && v.Legs[1]) res+= ',<br/> '+OrderSideMap[v.Legs[1].Action] + ' to ' + PositionEffectMap[v.Legs[1].PositionEffect]
                }

                return res;
            }
        }
//
//        cellClick(param:{row:number, column:number}){
//
//
//            OrderBus.$emit(<string>OrderMessages.OrderTableClick, param)
//
//        }
//
//        public getClassVal(v:number){
//            return OrderClassMap[v];
//        }
//        public getStatusVal(v:number){
//            return OrderStatusMap[v];
//        }
//        public  getTypeVal(v:number){
//            return OrderTypeMap[v];
//        }
//
//        public  getDurationVal(v:number){
//            return OrderDurationMap[v];
//        }
//        rows: any;
//
//        @Watch("data")
//        format(v:any,old:any){
//
//        }

   //     columns:string[]= ['Date','Description','Quantity','Action','OrderType','OrderStatus','OrderId']
//        columns: any[] =  [
//            {
//                label: 'Date',
//                field: 'Date',
//                type: 'date'
//                // inputFormat: 'YYYYMMDD',
//                // outputFormat: 'MMM Do YY',
//            },
//            {
//                label: 'Description',
//                field: 'Description',
//                filterable: true,
//            },
//            {
//                label: 'Qty',
//                field: 'Quantity',
//                type: 'number'
//            },
//            {
//                label: 'Action',
//                field: 'Action',
//
//            },
//            {
//                label: 'Order Type',
//                field: 'OrderType'
//            },
//            {
//                label: 'Order Status',
//                field: 'OrderStatus'
//            },
//            {
//                label: '',
//                field: 'OrderId'
//            }
//
//        ] as any[];

    });


</script>

<template>
    <WaitIndicator :inprogress="loading" :error="ErrorMessage">
        <div v-if="loaded" class="TbLoadedWrapper">            
            <v-client-table ref="TbOrderTable" id="TbOrderTable" :data="data" :columns="columns" :options="options">
                <span slot-scope="{row}" slot="Date" > {{row.Date | formatDate}} </span>
                <!--<span slot="Date" slote-scope="props"> {{getStatusVal(props.row.OrderStatus)}} </span>-->
                <!--<span slot-scope="{row}" slot="OrderClass"> {{getClassVal(row.OrderClass)}} </span>-->
                <!--<span slot-scope="{row}" slot="Duration"> {{}} </span>-->

                <span slot-scope="{row}" slot="OrderStatus"> {{getStatusVal(row.OrderStatus)}} </span>

                <span slot-scope="{row}" slot="BidPrice"> {{row.BidPrice | formatPrice}} </span>
                <span slot-scope="{row}" slot="AskPrice"> {{row.AskPrice | formatPrice}} </span>
                <span slot-scope="{row}" slot="ActionDesc" v-html="getAction(row)">  </span>
                <PriceCell :fixed="!editable" slot-scope="{row}" slot="OrderType" :order="row"/>

                <OrderActionMenu v-if="editable" slot-scope="{row}" slot="Actions" :order="row"/>

                <template slot="child_row" slot-scope="{row}" class="TbOrderTable__Row">
                        <h5 class="TbOrderTable_RowDetailsHeader">Details:</h5>
                        <span v-if="row.FilledQuantity" >FilledQuantity:{{row.FilledQuantity}},</span>
                        <span>Underlying:</span>{{row.UnderlyingSymbol}}
                        <span>Duration:</span>{{getDurationVal(row.Duration)}}
                        <div class="TbOrderTable__RowLegDescription">{{Leg0Description(row)}}</div>
                        <div class="TbOrderTable__RowLegDescription">{{Leg1Description(row)}}</div>


                </template>
                <template slot="beforeTable" >
                    <TableScroller id="#TbOrderTable" :outerWidth="scrollContWidth" :width="scrollWidth" v-model="scrollLeft" v-show="false"/>
                </template>

            </v-client-table>
            <!--<vue-good-table v-if="loaded"-->
                            <!--title="Dynamic Rows"-->
                            <!--:columns="columns"-->
                            <!--:rows="data"-->
                            <!--:lineNumbers="false"-->
                            <!--:defaultSortBy="{field: 'age', type: 'asc'}"-->
                            <!--:globalSearch="true"-->
                            <!--styleClass="basicGrid"-->
                            <!--@on-cell-click="cellClick"-->
            <!--&gt;-->
                <!--<template slot="table-row" slot-scope="props" >-->
                    <!--&lt;!&ndash;<td class="fancy">{{props.row.Date}}</td>-->
                    <!--<td class="fancy">{{ props.row.Description }}</td>-->
                    <!--<td class="has-text-right">{{ props.row.OrderClass }}</td>-->
                    <!--<td class="has-text-right">{{ props.row.OrderStatus }}</td>-->
                    <!--<td class="has-text-right">{{ props.row.OrderType }}</td>-->
                    <!--<td class="has-text-right">{{ props.row.Quantity }}</td>-->
                    <!--<td class="has-text-right">{{ props.row.Legs[0].FillQuantity }}</td>-->
                    <!--<td class="has-text-right">{{ props.row.Duration }}</td>-->
                    <!--<td class="has-text-right"> <OrderActionMenu :orderId="props.row.OrderId"/></td>&ndash;&gt;-->
                    <!--<td v-if="props.column.field == 'Date'">-->
                        <!--{{ props.row.Date | formatDate}}-->
                    <!--</td>-->
                    <!--<td v-else-if="props.column.field == 'OrderClass'">-->
                        <!--{{ getClassVal(props.row.OrderClass)}}-->
                    <!--</td>-->
                    <!--<td v-else-if="props.column.field == 'OrderStatus'">-->
                        <!--{{ getStatusVal(props.row.OrderStatus)}}-->
                    <!--</td>-->
                    <!--<td v-else-if="props.column.field == 'OrderType'">-->
                        <!--<PriceCell :order="props.row" />-->
                    <!--</td>-->
                    <!--<td v-else-if="props.column.field == 'Duration'">-->
                        <!--{{ getDurationVal(props.row.Duration)}}-->
                    <!--</td>-->


                    <!--<td v-else-if="props.column.field == 'OrderId'">-->
                       <!--<OrderActionMenu :order="props.row"/>-->
                    <!--</td>-->
                    <!--<td v-else>-->
                        <!--{{props.formattedRow[props.column.field]}}-->
                    <!--</td>-->
                <!--</template>-->

                <!--<div slot="emptystate">-->
                    <!--No data-->
                <!--</div>-->
            <!--</vue-good-table>-->
        </div>

        <div v-else>
            <div v-if="ErrorMessage && ErrorMessage.length>0">
                <h4 class="center-text">Error:{{ErrorMessage}}</h4>
            </div>
        </div>
    </WaitIndicator>

</template>

<style>
    .VueTables__child-row {
        margin: auto;
    }

    .VueTables__child-row span{
        margin-right: .5rem;
    }
</style>